import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { BulkPlaylistTagDocument } from './bulk.generated';

export const useBulkPlaylistTag = (options: ApiOptions<typeof BulkPlaylistTagDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(BulkPlaylistTagDocument, {
    ...useNotifications(BulkPlaylistTagDocument, {
      failure: t('api.playlist_tags.bulk_add_error'),
      success: (data) => {
        const count = data.bulkTag?.taggables.length ?? 0;
        return t('api.playlist_tags.bulk_add_success_plural', { count });
      },
    }),
    ...options,
  });
};
